/**
 * Legacy module shell — kept so AngularJS modules that declare
 * 'acme.common.service.auditTrailGrids' as a dependency keep bootstrapping.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/audit-trail/audit-trail-grids.service.ts
 *
 * Registered with AngularJS via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any $inject = ['AuditTrailGridsService'] resolves to the Angular 18 class.
 */
angular.module('acme.common.service.auditTrailGrids', []);
